// Reducers needed for public questions and dashboards

import { commonReducers } from "./reducers-common";

export const publicReducers = {
  ...commonReducers,
};
